import { string, z } from 'zod'

const outputMappingSourceSchema = z.enum([
  'execution-response',
  'json-path',
  'json-path-file-base64',
  'json-path-file-url',
  'file-binary',
])
export type OutputMappingSource = z.infer<typeof outputMappingSourceSchema>

const fileExtractionSchema = z.object({
  contentPath: z.string().optional(),
  urlPath: z.string().optional(),
  filenamePath: z.string().optional(),
  mimeTypePath: z.string().optional(),
  defaultFilename: z.string().optional(),
  defaultMimeType: z.string().optional(),
})

export type FileExtraction = z.infer<typeof fileExtractionSchema>

export const outputMappingSchema = z.record(
  z.string(),
  z.object({
    source: outputMappingSourceSchema,
    value: string(),
    jsonPath: string().optional(),
    fileExtraction: fileExtractionSchema.optional(),
  })
)

export type OutputMapping = z.infer<typeof outputMappingSchema>
